import type { LegendSymbol } from "../types";

import "./LayerLegend.css";

export function LegendSymbolIcon({ symbol }: { symbol: LegendSymbol }) {
  return symbol.icon?.format === "png" && symbol.icon.data ? (
    <img
      className="legend-icon"
      src={`data:image/png;base64,${symbol.icon.data}`}
      alt=""
    />
  ) : (
    <span className="legend-fallback" />
  );
}
